module.exports = __webpack_public_path__ + "img/ch4.bda39bc2.png";